"use strict";
export function numberToHex(number) {
  return ensure0xHex(number.toString(16));
}
export function hexToNumber(hex) {
  if (hex.startsWith("0x")) {
    return parseInt(hex.slice(2), 16);
  }
  return parseInt(hex, 16);
}
export function ensure0xHex(hex) {
  return hex.startsWith("0x") ? hex : `0x${hex}`;
}
export function isValidHexString(value) {
  return /^0x[0-9a-fA-F]+$/.test(value);
}
